import { notification, Modal } from 'antd';
import ApiService from 'utils/ApiCalls';

const { confirm } = Modal;

interface DeleteRecordParams {
  id: number;
  tableName: string;
  onSuccess?: () => void;
}

export const deleteRecord = ({
  id,
  tableName,
  onSuccess,
}: DeleteRecordParams) => {
  confirm({
    title: 'Confirm Inactivation',
    content:
      'Once deleted, this record cannot be restored and may affect dependent records. Would you like to continue?',
    okText: 'Yes',
    cancelText: 'No',
    onOk: async () => {
      try {
        const dependencyResponse = await ApiService.checkDeleteDependency(
          id,
          tableName,
        );

        const { status, message } = dependencyResponse.data;

        if (status === 'blocked') {
          const tables = dependencyResponse.data.references
            .map((ref: any) => `${ref.table} (${ref.count})`)
            .join(', ');

          notification.warning({
            message: 'Cannot Delete',
            description: `${message}
        
        Total References: ${dependencyResponse.data.total_references}
        
        Referenced In: ${tables}`,
            duration: 20,
          });

          return;
        }

        if (status === 'allowed') {
          await ApiService.softDeleterecord(id, tableName, true);

          notification.success({
            message: 'Success',
            description: 'Record deleted successfully.',
            duration: 20,
          });

          onSuccess?.();
        }
      } catch (error) {
        console.error(error);

        notification.error({
          message: 'Error',
          description: 'An unexpected error occurred.',
          duration: 20,
        });
      }
    },
  });
};
